import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCampaignsCreateDefaultCacheKeys: AllRouteEndpoints[] = [];
